import React, { forwardRef } from "react";
import { Link } from "react-router-dom";
import styles from "../WelcomePage.module.css";

/** Alineado con header landing y doc z3312 (hero responsive). */
export const HERO_MOBILE_MAX_WIDTH_PX = 768;

/**
 * @param {object} props
 * @param {object} props.hero
 * @param {boolean} props.heroReady
 */
const LandingHero = forwardRef(function LandingHero({ hero, heroReady }, ref) {
  const ctaHref = hero.cta_link?.startsWith("http")
    ? hero.cta_link
    : hero.cta_link || "/auth";
  const isExternal = ctaHref.startsWith("http");
  const desktopBg = hero.background_image_url || null;
  const mobileBg =
    hero.background_image_mobile_url || hero.background_image_url || null;
  const hasBgImage = Boolean(desktopBg || mobileBg);

  const Cta = isExternal ? (
    <a href={ctaHref} className={styles.ctaButton} rel="noreferrer">
      {hero.cta_text}
    </a>
  ) : (
    <Link
      to={ctaHref}
      className={styles.ctaButton}
      state={{ mode: "registro", returnTo: "/apuestas" }}
    >
      {hero.cta_text}
    </Link>
  );

  return (
    <section
      ref={ref}
      className={`${styles.hero} ${styles.heroSuperbanner} ${heroReady ? styles.heroEnter : ""} ${hasBgImage ? styles.heroWithBg : ""}`}
    >
      {hasBgImage && (
        <div className={styles.heroBgLayer} aria-hidden>
          <picture className={styles.heroBgPicture} style={{ width: "100%", maxWidth: "100%", display: "block" }}>
            {mobileBg ? (
              <source
                media={`(max-width: ${HERO_MOBILE_MAX_WIDTH_PX}px)`}
                srcSet={mobileBg}
              />
            ) : null}
            <img
              src={desktopBg || mobileBg}
              alt=""
              className={styles.heroBgImg}
              decoding="async"
              fetchPriority="high"
              sizes="100vw"
              style={{ width: "100%", maxWidth: "100%", height: "auto", objectFit: "contain" }}
            />
          </picture>
        </div>
      )}
      {hasBgImage && <div className={styles.heroScrim} aria-hidden />}
      {!hasBgImage && <div className={styles.heroOrbs} aria-hidden />}
      <div className={styles.heroContent}>
        <h1 className={styles.heroTitle}>{hero.title}</h1>
        {hero.subtitle && (
          <p className={styles.heroSubtitle}>{hero.subtitle}</p>
        )}
        {hero.promo_image_url && (
          <img
            src={hero.promo_image_url}
            alt=""
            className={styles.heroPromoImage}
          />
        )}
        {Cta}
      </div>
    </section>
  );
});

export default LandingHero;
